// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Su6U","header":"styles_header__2Q8vC"};